import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'
import { goToSlide, registerSlideshow } from './slideshow-helpers'

export default class SlideshowThumbnails {
  /**
   * @type {LiveNodeList}
   */
  thumbnailItems = new LiveNodeList('.slideshow-thumbnails')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.thumbnailItems.on('update', (newItems, oldItems) => {
      newItems.forEach(this.registerSlideshow)
      oldItems.forEach(this.unregisterSlideshow)
    })

    this.thumbnailItems.forEach(this.registerSlideshow)
  }

  @bind
  registerSlideshow(item) {
    const target = document.getElementById(item.getAttribute('aria-controls'))
    registerSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
    })

    window.addEventListener(
      'resize',
      this.handleResize.bind(this, item, target),
    )

    item.querySelectorAll('.slideshow-thumbnails__item').forEach(button => {
      button.addEventListener('click', () =>
        goToSlide(target, button.dataset.index),
      )
    })
  }

  @bind
  unregisterSlideshow(item) {
    unregisterSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
      onUpdateChildren: () => {
        this.handleScroll(item, target)
      },
    })
    window.removeEventListener(
      'resize',
      this.handleResize.bind(this, item, target),
    )
  }

  @bind
  handleResize(item, target, event) {
    clearTimeout(item.resizeCallback)

    item.resizeCallback = setTimeout(() => {
      this.handleScroll(item, target)
    }, 250)
  }

  @bind
  handleScroll(item, target, event) {
    const selected = target.querySelector('[aria-current="true"]')
    const index = Array.from(target.children).indexOf(selected)

    const children = Array.from(
      item.querySelectorAll('.slideshow-thumbnails__item'),
    )

    children.forEach(child => child.setAttribute('aria-current', 'false'))
    let current = children[0]
    for (let child of children) {
      if (parseInt(child.dataset.index) >= index) {
        current = child
        break
      }
    }

    current.setAttribute('aria-current', 'true')
    goToSlide(item, current.dataset.index)
  }
}
